<script setup lang="ts">
const { isDesktop } = useDevice();
</script>

<template>
  <div class="request">
    <div class="request-catch">
      カンタン３分！<b>最短即日</b>見積もり
    </div>
    <div class="request-button">
      <a href="/step/step_init.html" class="button-step1"
        ><span>無料</span>
        <div>見積もり依頼スタート！</div></a
      >
      <a id="button-kyousai" href="https://www.zenrosai.coop/kyousai/kasai/lp/campaign-index-3.html?utm_source=Unknown&utm_medium=not_payid&utm_term=&utm_content=&utm_campaign=Kantou&argument=Q6fa96MK&dmai=a656007e4db9da" target="_blank" class="button-kyousai"> 火災共済をご希望の方はこちら<br><span>（こくみん共済 coop サイト）</span></a>
      <div class="other-button">
        <a
          v-if="isDesktop"
          href="https://www.zurichssi.co.jp/kazai-lp/?utm_medium=sdzp&utm_source=siwcad&utm_campaign=bn&utm_content=common&ssi_agencyCode=000"
          class="button-lease"
          target="_blank"
          rel="noopener"
          ><div>賃貸物件の方はこちら</div>
          <span>（外部サイト）</span></a
        >
        <a
          v-else
          href="https://www.zurichssi.co.jp/kazai-lp/?utm_medium=sdzp&utm_source=siwcad&utm_campaign=bn&utm_content=common&ssi_agencyCode=000"
          class="button-lease"
          target="_blank"
          rel="noopener"
          ><div>賃貸物件の方はこちら</div>
          <span>（外部サイト）</span></a
        >
        <a href="/hojin/step/step_init.html" class="button-hojin"
          ><div>法人向け火災保険はこちら</div></a
        >
      </div>
    </div>
    <!-- .request -->
  </div>
</template>

<style lang="scss" scoped>
.button-step1 {
  margin: 0 auto 3%;
  padding: 4.4% 0;
  border-radius: 6px;
  width: 100%;
  display: block;
  color: #fff;
  font-weight: bold;
  background-color: $colorBasicButton;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.16);
  text-decoration: none;
  text-align: center;
  box-sizing: border-box;
  transition: 0.1s all;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0.3);

  > {
    span {
      margin: 0 0.1em 0 0;
      padding: 0.2em 0.2em 0.3em;
      display: inline-block;
      color: #f00;
      font-weight: 700;
      background-color: #ff0;
      line-height: 1;
      vertical-align: middle;
    }

    div {
      padding: 0 8% 0 0;
      display: inline-block;
      color: #fff;
      font-size: px(19);
      font-weight: 700;
      background: url(~/assets/images/arrow_orange_sp.png) no-repeat right
        center;
      background-size: 10% auto;
      vertical-align: middle;
      text-shadow: 2px 2px 0px rgba(241, 90, 36, 0.4);
    }
  }
}

.button-lease {
  margin: 0 auto 3%;
  padding: 3% 1% 3% 6%;
  border-radius: 4px;
  width: 93%;
  display: block;
  background: $colorSubButton url(~/assets/images/arrow_blue_sp.png) no-repeat
    94% center;
  background-size: 7% auto;
  text-align: left;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.16);
  text-decoration: none;
  box-sizing: border-box;

  > div {
    margin: 0 auto;
    display: inline-block;
    color: $colorBlue;
    font-weight: 700;
  }

  span {
    margin: 0 0 0 -0.8%;
    display: inline-block;
    color: #333;
    font-size: px(9.9);
    font-weight: 400;
  }
}

.button-hojin {
  margin: 0 auto;
  padding: 3% 1% 3% 6%;
  border-radius: 4px;
  width: 93%;
  display: block;
  background: $colorSubButton url(~/assets/images/arrow_blue_sp.png) no-repeat
    94% center;
  background-size: 7% auto;
  text-align: center;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.16);
  text-decoration: none;
  text-align: left;
  box-sizing: border-box;

  > div {
    margin: 0 auto;
    display: inline-block;
    color: $colorBlue;
    font-weight: 700;
  }
}

.request {
  margin: 0 4% 12%;
  border: 4px solid $colorBlue;
  background-color: $colorBasicBackground;
}

.request-catch {
  margin: 0.3em auto 0.5em;
  width: 15.6em;
  display: block;
  color: #fff;
  font-size: px(18);
  font-weight: 700;
  position: relative;
  text-align: center;
  text-shadow: 2px 2px 0 rgba(30, 134, 198, 0.4);

  &::before,
  &::after {
    content: '';
    width: 1px;
    height: 80%;
    display: block;
    background-color: #fff;
    position: absolute;
    top: 15%;
  }

  &::before {
    left: -0.4em;
    transform: rotate(-45deg);
  }

  &::after {
    right: -0.4em;
    transform: rotate(45deg);
  }

  b {
    color: #fff800;
    font-weight: 700;
  }
}

.request-button {
  padding: 5% 4%;
  background-color: #fff;
  text-align: center;
}

.button-kyousai {
  margin: 0 0 4.8%;
  display: inline-block;
  text-align: center;
  color: #148cde;
  font-size: 94%;
  text-decoration: underline;
  span {
    font-size: 79%;
  }
}

@include media(pc) {
  .button-step1 {
    margin: 0 auto 14px;
    padding: 21px 0;
    width: 582px;
    box-shadow: 0px 4px 0px 0px rgba(0, 0, 0, 0.16);

    &:hover {
      background-color: #f78c35;
    }

    > {
      span {
        margin: 0 0.7em 0 0;
        padding: 0.2em 0.2em 0.3em;
        font-size: px(19.9);
      }

      div {
        margin-left: -0.1%;
        padding: 0 8% 0 0;
        font-size: px(30);
        background: url(~/assets/images/arrow_orange_sp.png) no-repeat right
          center;
        background-size: 28px 28px;
      }
    }
  }

  .button-lease {
    margin: 0 16px 0 0;
    padding: 15px 10px;
    width: 303px;
    background: $colorSubButton url(~/assets/images/arrow_blue_sp.png)
      no-repeat right 12px center;
    background-size: 20px 20px;
    vertical-align: middle;
    box-shadow: 0px 4px 0px 0px rgba(0, 0, 0, 0.16);
    border-radius: 6px;
    text-align: center;

    &:hover {
      background: #efefef url(~/assets/images/arrow_blue_sp.png) no-repeat
        right 12px center;
      background-size: 20px 20px;
    }

    > div {
      font-size: px(16);
    }

    span {
      font-size: px(12);
    }
  }

  .button-hojin {
    margin: 0 auto;
    padding: 15px 0 15px 22px;
    width: 263px;
    background: $colorSubButton url(~/assets/images/arrow_blue_sp.png)
      no-repeat right 21px center;
    background-size: 20px 20px;
    vertical-align: middle;
    box-shadow: 0px 4px 0px 0px rgba(0, 0, 0, 0.16);

    &:hover {
      background: #efefef url(~/assets/images/arrow_blue_sp.png) no-repeat
        right 21px center;
      background-size: 20px 20px;
    }

    > div {
      font-size: px(16);
    }
  }

  .request {
    margin: 0 0 80px;
    border: 6px solid $colorBlue;
    border-radius: 4px;
  }

  .request-catch {
    margin: 0.3em auto;
    width: 15.6em;
    font-size: px(27.9);

    &::before,
    &::after {
      content: '';
      width: 1px;
      height: 80%;
      display: block;
      background-color: #fff;
      position: absolute;
      top: 15%;
    }

    &::before {
      left: -0.4em;
      transform: rotate(-45deg);
    }

    &::after {
      right: -0.4em;
      transform: rotate(45deg);
    }

    b {
      color: #fff800;
      font-weight: 700;
    }
  }

  .request-button {
    padding: 26px 0 31px;
    background-color: #fff;
  }

  .other-button {
    margin: 0 auto;
    display: flex;
    width: 582px;
  }

  .button-kyousai {
    margin: 0 0 20px;
    font-size: 100%;
    line-height: 15px;
    span {
      font-size: 74%;
    }
    br {
      display: none;
    }
  }
}
</style>
